<template>
  <div class="title-chart">
    <el-row
      class="row-chart"
      style="height: 60px;">
      <el-col :span="6">
        <p class="title">Primer Trimestre</p>
        <p>Enero - Marzo {{ year }}</p>
      </el-col>
      <el-col :span="6">
        <p class="title">Segundo Trimestre</p>
        <p>Abril - Junio {{ year }}</p>
      </el-col>
      <el-col :span="6">
        <p class="title">Tercer Trimestre</p>
        <p>Julio - Septiembre {{ year }}</p>
      </el-col>
      <el-col :span="6">
        <p class="title">Cuarto Trimestre</p>
        <p>Octubre - Diciembre {{ year }}</p>
      </el-col>
    </el-row>
    <el-row
      class="row-chart"
      style="height: 210px;">
      <el-col
        :span="6"
        style="padding: 5px 20px;">
        <pie-chart
          :labels="labels"
          :datasets="data[0]"/>
      </el-col>
      <el-col
        :span="6"
        style="padding: 5px 20px;">
        <pie-chart
          :labels="labels"
          :datasets="data[1]"/>
      </el-col>
      <el-col
        :span="6"
        style="padding: 5px 20px;">
        <pie-chart
          :labels="labels"
          :datasets="data[2]"/>
      </el-col>
      <el-col
        :span="6"
        style="padding: 5px 20px;">
        <pie-chart
          :labels="labels"
          :datasets="data[3]"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
*
* TitleChart Component
*
* @author emartinez
* @copyright 2019, Marciano Studio S.C.
*/
import PieChart from '@/components/_shared/charts/pie-chart'
import moment from 'moment'
export default {
  name: 'TitleChart',
  components: {
    PieChart
  },
  props: {
    year: {
      type: String,
      default: moment().format('YYYY')
    },
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-chart {
  height: 100%;
  border: 1px solid #ebeef5;
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  .row-chart{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    .title{
      margin: 0 0 10px 0;
      color: #444444;
      @include font-lato(11px, bold);
    }
    p{
      text-align: center;
      margin: 0 0 10px 0;
      color: #9D9D9D;
      @include font-lato(11px, bold);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/title-chart.vue